import React from 'react';

import Icon from '../../../../../../components/Icon';
import TrackingNFEmailTracking from '../../../EmailTracking';

import {
  EmailTrackingContainer,
  FooterContainer,
  OcurrencesWrapper,
} from './styles';

const TrackingFooter = ({ 
  nfData, 
  hasOccurence, 
  openOccurence, 
  isMobile, 
}) => (
  <FooterContainer>
    <OcurrencesWrapper isMobile={isMobile} hasOccurence={hasOccurence}>
      <div onClick={hasOccurence && openOccurence}>
        <Icon name="error_outline" />
        {hasOccurence ? (
          <span>Ocorrências na viagem</span>
        ) : (
          <span>Viagem sem ocorrências</span>
        )}
      </div>
    </OcurrencesWrapper>
    <EmailTrackingContainer>
      <TrackingNFEmailTracking
        icon={null}
        label="Habilitar notificações"
        className="TrackingNFItem__email-tracking"
        nfData={nfData}
      />
    </EmailTrackingContainer>
  </FooterContainer>
);

export default TrackingFooter;
